import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import ApiCalls from '../../custom-classes/api-calls';
import ListItem from '@material-ui/core/ListItem';
import {Col, Row} from 'reactstrap';

/**
 * Handle the checkboxes of the taxes
 */
class CheckboxTaxes extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            checkedItems: new Map(),
            checkboxes: [],
            checkedValues: [],
            disabled: props.disabled
        };

        if (typeof props !== 'undefined') {
            this.state = {
                checkedItems: new Map(),
                checkboxes: [],
                checkedValues: props.data.taxesSelected,
                disabled: props.disabled
            };
        }

        this.handleChange = this.handleChange.bind(this);
    }

    componentWillReceiveProps(nextProps){
        this.setState({
            disabled: nextProps.disabled,
            checkedValues: nextProps.data.taxesSelected !== null
            && typeof nextProps.data.taxesSelected !== 'undefined' ? nextProps.data.taxesSelected : []
        });
    }

    /**
     * Mounts the data. Call the data from the server and sets the data to the list
     */
    mountData() {
        // This is promise
        let apiCall = ApiCalls.getTaxes();

        // After the api call, fill the data
        apiCall.then((data)=> {

            let options = [];
            let dataReturned = data.Taxes;

            // Now fill the selections
            for (let i = 0; i < dataReturned.length; i++) {
                let name = dataReturned[i].TaxName;
                if (dataReturned[i].StateIso === null) // State is optional.
                    name += ' (' + dataReturned[i].CountryIso + ')';
                else
                    name += ' (' + dataReturned[i].StateIso + ', ' + dataReturned[i].CountryIso + ')';

                options.push({
                    name: name,
                    key: dataReturned[i].Id,
                    label: dataReturned[i].Id,
                    checked: this.state.checkedValues.indexOf(dataReturned[i].Id) > -1
                });
            }
            return options;
        }).then((options)=> {
            this.setState({checkboxes: options});
        });
    }

    /**
     * Action when the component will mount
     */
    componentDidMount() {
        this.mountData();

    }

    /**
     * Removes a value from array
     * @param array
     * @param xToRemove
     * @returns {*}
     */
    removeFromArray(array, xToRemove) {
        for (let i = array.length - 1; i >= 0; i--) {
            if (array[i] === xToRemove) {
                array.splice(i, 1);
            }
        }
        return array;
    }

    /**
     * Add a value to an array
     * @param array
     * @param xToAdd
     * @returns {*}
     */
    insertInArrayIfNotExists(array, xToAdd) {
        if (array.includes(xToAdd))
            return array;
        else {
            array.push(xToAdd);
            return array;
        }
    }

    /**
     * Action when the checkbox changes
     * @param e
     */
    handleChange(e) {
        const isChecked = e.target.checked;
        const value = e.target.value;

        this.setState(prevState => ({checkedItems: prevState.checkedItems.set(value, isChecked)}), ()=> {
            let newArray = [];
            if (this.state.checkedItems.get(value)) {
                newArray = this.insertInArrayIfNotExists(this.state.checkedValues, value);
            }
            else {
                newArray = this.removeFromArray(this.state.checkedValues, value);
            }

            this.setState({
                checkedValues: newArray
            }, ()=> {
                this.props.updateParent(this.state.checkedValues);
                return this.state.checkedValues;
            });
        });
    }

    render() {
        return (
            <Row>
                {
                    this.state.checkboxes.map(item => (
                        <Col sm={{size: 6}} key={item.key}>
                            <ListItem key={item.key} dense button>
                                <Checkbox name={item.name}
                                          value={item.key}
                                          checked={this.state.checkedValues.includes(item.key)}
                                          onChange={this.handleChange}
                                          disabled={this.state.disabled}
                                />
                                <small><label key={item.key}> {item.name} </label></small>
                            </ListItem>
                        </Col>
                    ))
                }
            </Row>
        );
    }
}

export default CheckboxTaxes;